import { render, staticRenderFns } from "./boxAttachment.vue?vue&type=template&id=3b66096c&"
import script from "./boxAttachment.vue?vue&type=script&lang=js&"
export * from "./boxAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports